import { FC, ReactNode, useCallback, useEffect } from 'react';

import { setMapMode } from 'store/mapSlice';
import { RootState } from 'store/rootReducer';

import { useAppDispatch, useAppSelector } from 'hooks/defaultStoreHooks';
import { useInitialFocusOnExtent } from 'hooks/useInitialFocusOnExtent';

import AktivitetBaseInfo from 'components/aktivitetPresentation/AktivitetBaseInfo';
import PubliceradeBebyggelseobjekt from 'components/aktivitetPresentation/publiceradeBebyggelseobjekt/PubliceradeBebyggelseobjekt';
import { DrawerBody, DrawerSection } from 'components/drawerSections/DrawerSections';
import { replaceBebyggelseobjektFeaturesInActiveSource } from 'components/map/Layers';

import { MapModeEnum } from 'enums';

const MigreringPresentation: FC = (): ReactNode => {
  const dispatch = useAppDispatch();
  const { data: aktivitet } = useAppSelector((state: RootState) => state.aktivitet);
  const publiceradeBebyggelseobjekt = useAppSelector((state: RootState) => state.publiceradeBebyggelseobjekt);

  const migreringsAktivitet = aktivitet?.migrering;

  useEffect(() => {
    dispatch(setMapMode(MapModeEnum.ACTIVE_LAYERS_ONLY));
  }, [dispatch]);

  useInitialFocusOnExtent(
    useCallback(
      () => replaceBebyggelseobjektFeaturesInActiveSource(publiceradeBebyggelseobjekt.data),
      [publiceradeBebyggelseobjekt.data]
    )
  );

  return (
    <DrawerBody>
      {migreringsAktivitet && <AktivitetBaseInfo aktivitet={migreringsAktivitet} />}
      <DrawerSection>
        <h2 className="tw-heading-md tw-mb-2">Berörda objekt ({publiceradeBebyggelseobjekt.data?.length ?? 0})</h2>
        <PubliceradeBebyggelseobjekt
          list={publiceradeBebyggelseobjekt.data}
          error={publiceradeBebyggelseobjekt.error}
          requestStatus={publiceradeBebyggelseobjekt.requestStatus}
        />
      </DrawerSection>
    </DrawerBody>
  );
};

export default MigreringPresentation;
